import React, { useState, useEffect } from 'react';
import { Lock, Logo, QstMrk } from '../Svg';

export default function NavBar() {
    const [currentUrl, setCurrentUrl] = useState('');
    useEffect(() => {
        setCurrentUrl(window.location.href);
    }, []);

    return (
        <nav className="flex flex-col bg-transparent justify-center w-full fixed top-0 z-50">
            <div className="flex flex-col sm:flex-row justify-center items-center bg-[#fbbf24] h-[40px] sm:h-[30px] w-full p-2 sm:p-0">
                <h1 className="text-[12px] text-[#6e6141] flex flex-col sm:flex-row items-center gap-[4px] text-center">
                    Please protect your funds. Make sure the URL is
                    <span className="text-black flex items-center gap-[3px] font-[700]">
                        {Lock} {currentUrl}
                    </span>
                </h1>
            </div>
            <div className="flex sm:flex-row items-center w-full h-[60px] bg-[#171717] bg-opacity-20 backdrop-blur-sm sm:justify-between px-[20px] py-[10px]">
                <div className="flex-1 sm:flex-none flex justify-center sm:justify-start">
                    {Logo}
                </div>
                <h1 className="hidden sm:block text-[24px] text-white">
                    Connect Your Wallet
                </h1>
                <div className="hidden sm:flex w-[50px] h-[50px] rounded-full bg-[#262626] items-center justify-center text-[#5c5c5c] cursor-pointer hover:bg-[#404040] hover:text-[#23f7dd] relative group">
                    {QstMrk}
                    <span className="absolute bottom-[-40px] transform -translate-x-1/2 text-[#5c5c5c] text-[12px] rounded-[10px] px-3 py-1 bg-[#171717] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 border border-[1px] border-[#5c5c5c]">
                        <a href="https://docs.multiversx.com/" target='_blank'> Documentation </a>
                    </span>
                </div>
            </div>
        </nav>
    );
}
